module.exports = __webpack_public_path__ + "static/2014-layer-3-96cd18a16b0d3197dcd00454451323c3.png";